import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { mdiAutorenew, mdiClose } from '@lumapps/lumx/icons';
import { UserCard, DEFAULT_FIELDS } from '@lumapps/user/components/UserCard';
import { User } from '@lumapps/user/types';

const CLASSNAME = 'ask-ai-user-card';

export interface AskAiUserCardProps {
    user: User;
    /** callback to be executed when the user card is being edited */
    onEdit?: () => void;
    /** callback to be executed when the user card is being removed */
    onRemove?: () => void;
    /** whether the follow button should be disabled or not */
    isFollowButtonDisabled?: boolean;
    /** Classname to set on the user card */
    className?: string;
}

/**
 * Display the given user card if a user object is returned in the best answer.
 */
export const AskAiUserCard = ({ user, onEdit, onRemove, isFollowButtonDisabled, className }: AskAiUserCardProps) => {
    const { block } = useClassnames(CLASSNAME);

    return (
        <UserCard
            user={user}
            fields={DEFAULT_FIELDS.filter((field) => field !== 'email')}
            showFollow
            onEdit={onEdit}
            onRemove={onRemove}
            onEditIcon={mdiAutorenew}
            onRemoveIcon={mdiClose}
            className={block([className])}
            defaultIsSubscribed={user.isFollowed}
            isFollowButtonDisabled={isFollowButtonDisabled}
        />
    );
};
